import React, { createContext, useContext, useState } from 'react';

/**
 * @typedef {Object} HeaderContextType
 * @property {number} height - Current header height
 * @property {(h: number) => void} setHeight - Function to update the header height
 */

/** @type {React.Context<HeaderContextType>} */
const HeaderContext = createContext({
  height: 0,
  setHeight: (_height) => {},
});

/**
 * Description placeholder
 *
 * @param {object} param0
 * @param {React.ReactNode} param0.children
 */
export const HeaderProvider = ({ children }) => {
  const [height, setHeight] = useState(0);
  return (
    <>
      {/* @ts-ignore */}
      <HeaderContext.Provider value={{ height, setHeight }}>
        {children}
      </HeaderContext.Provider>
    </>
  );
};

/**
 * Custom hook to access header context.
 * @returns {HeaderContextType}
 */
export const useHeader = () => useContext(HeaderContext);
